import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import {
  ConsumidorAdicionalComponent, ConsumidorAlterarSenhaComponent,
  ConsumidorCadastrarComponent, ConsumidorCartaoComponent, ConsumidorDescadastrarComponent,
  ConsumidorDetalharComponent, ConsumidorEditComponent, ConsumidorInstituicaoComponent,
  ConsumidorLoginComponent, ConsumidorMsgSenhaAlteradaComponent,
  ConsumidorSenhaLogadoComponent,
  ConsumidorNotasComponent,
  ConsumidorBilhetesComponent,
  ConsumidorPremiosComponent,
  ConsumidorDetalheSorteioComponent,
  ConsumidorVisualizarBilhetesComponent,
  ConsumidorObrigadoComponent
} from './';
import { AuthGuard } from '../guard/auth.guard';
import { ConsumidorDemonstrativoImpostoRendaComponent } from './consumidor-demonstrativo-imposto-renda/consumidor-demonstrativo-imposto-renda.component';
import { ConsumidorTermoLgpdComponent } from './consumidor-lgpd/consumidor-termo-lgpd';
import { ConsumidorLoginGovBrComponent  } from './consumidor-login-gov-br/consumidor-login-gov-br.component';
import { ConsumidorCadastrarSenhaExternoComponent } from './consumidor-cadastrar-senha-externo/consumidor-cadastrar-senha-externo.component';
import { ConsumidorAtualizarCadastroComponent } from './consumidor-atualizar-cadastro/consumidor-atualizar-cadastro.component';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: '',
        component: ConsumidorLoginComponent
      },
      {
        path: 'instituicoes',
        component: ConsumidorInstituicaoComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'login',
        component: ConsumidorEditComponent
      },
      {
        path: 'govbr/login', 
        component: ConsumidorLoginGovBrComponent
      },            
      {
        path: 'cadastro_consumidor',
        component: ConsumidorCadastrarComponent
      },
      {
        path: 'obrigado',
        component: ConsumidorObrigadoComponent
      },
      {
        path: 'cadastro_dados_adicionais',
        component: ConsumidorAdicionalComponent
      },
      {
        path: 'detalhar',
        component: ConsumidorDetalharComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'detalhar/:cpf',
        component: ConsumidorDetalharComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'dados_consumidor',
        component: ConsumidorEditComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'recuperar_senha',
        component: ConsumidorAlterarSenhaComponent
      },
      {
        path: 'alterar_senha_logado',
        component: ConsumidorSenhaLogadoComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'descadastrado',
        component: ConsumidorDescadastrarComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'alterar_senha',
        component: ConsumidorAlterarSenhaComponent
      },
      {
        path: 'msg_alterar_senha',
        component: ConsumidorMsgSenhaAlteradaComponent
      },
      {
        path: 'meu_cartao',
        component: ConsumidorCartaoComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'recuperacaoSenha',
        component: ConsumidorAlterarSenhaComponent
      },
      {
        path: 'notas',
        component: ConsumidorNotasComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'bilhetes',
        component: ConsumidorBilhetesComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'premios',
        component: ConsumidorPremiosComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'detalhe_sorteio/:id',
        component: ConsumidorDetalheSorteioComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'visualizar_bilhetes',
        component: ConsumidorVisualizarBilhetesComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'demonstrativo_imposto_renda',
        component: ConsumidorDemonstrativoImpostoRendaComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'termo-lgpd',
        component: ConsumidorTermoLgpdComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'cadastrar-senha-externo',
        component: ConsumidorCadastrarSenhaExternoComponent
      },
      {
        path: 'atualizar-cadastro',
        component: ConsumidorAtualizarCadastroComponent,
        canActivate: [AuthGuard]
      }
    ])
  ],
  exports: [
    RouterModule
  ]
})
export class ConsumidorRoutingModule {
}



// WEBPACK FOOTER //
// ./src/app/restrito/consumidor/consumidor.routing.module.ts